import { render, staticRenderFns } from "./RedirectSSOPage.vue?vue&type=template&id=78940131&"
import script from "./RedirectSSOPage.vue?vue&type=script&lang=js&"
export * from "./RedirectSSOPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports